/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedfirstreminderleadtime4Inputs */

const en__field_inheritedfirstreminderleadtime4 = /** @type {(inputs: _Field_Inheritedfirstreminderleadtime4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First Reminder x Days ahead (inherited)`)
};

const de__field_inheritedfirstreminderleadtime4 = /** @type {(inputs: _Field_Inheritedfirstreminderleadtime4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Erinnerung x Tage vorher (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "First Reminder x Days ahead (inherited)" |
*
* @param {_Field_Inheritedfirstreminderleadtime4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedfirstreminderleadtime4 = /** @type {((inputs?: _Field_Inheritedfirstreminderleadtime4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedfirstreminderleadtime4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedfirstreminderleadtime4(inputs)
	return de__field_inheritedfirstreminderleadtime4(inputs)
});
export { _field_inheritedfirstreminderleadtime4 as "_field_inheritedFirstReminderLeadTime" }